<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-card
          title="Documento de usuario a buscar"
          id="qr_entrega"
          class="text-uppercase text-center"
        >
          <b-btn variant="success" @click="mostrar = !mostrar">Preparar</b-btn>
          <qrcode-reader v-if="mostrar" @decode="onDecode" style="width:100%"></qrcode-reader>
        </b-card>
      </b-col>
      <b-col style="position:relative;height:460px;overflow-y:auto">
        <b-row>
          <b-col md="3" class="text-center" v-for="item in items" :key="item.id">
            <b-card
              :title="(item.name.split(' ').length>2 ? item.name.split(' ')[0] + ' ' +item.name.split(' ')[2]  : item.name)"
              class="text-uppercase"
            >
              <b-row>
                <b-col md="12">
                  <b-img fluid-grow rounded="circle" style="height:100%;" v-bind:src="item.img"></b-img>
                </b-col>
                <b-col>
                  <br>
                  <h3>#{{item.turno}}</h3>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "restaurantqr",
  data: function() {
    return {
      mainPath: "",
      varMensaje: "",
      varImg: "",
      varimgtext: "",
      mostrar: true,
      contador: 0,
      reloj: null,
      items: []
    };
  },
  mounted() {
    this.contador = 6;
  },
  methods: {
    getData() {
      if (this.contador < 6) {
        this.contador++;
        console.log(this.contador);
      } else {
        this.$store
          .dispatch("restauranteRequestsAllReady")
          .then(response => {
            this.items = this.$store.getters.cafeteriaRequestsExt.turns;
            this.items.forEach(element => {
              let mainPath = localStorage.getItem("urlApi");
              mainPath = mainPath.replace("/api", "");
              element.img = mainPath + element.url;
            });
            this.contador = 0;
            this.reload();
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    onDecode: function(decode) {
      this.mostrar = false;
      if (decode.length > 2) {
        this.$store
          .dispatch("restaurantRequestsqracces", decode)
          .then(response => {
            this.varMensaje = this.$store.getters.restaurantRequests.mensaje;
            this.varImg = this.$store.getters.restaurantRequests.img;
            if (this.varMensaje && this.varMensaje != "") {
              this.url();
              this.$root.showInfoDialog("alerta", this.varimgtext, "Aceptar");
              this.contador = 7;
              this.getData();
              setTimeout(()=>{
                this.$root.closeInfoDialog();
                this.mostrar = true;
              },2000)
            } else {
              this.varMensaje =
                "Hubo un error en la transaccion por favor intenta nuevamente";
              this.varImg = "Photo_icon.png";
            }
          });
      } else {
        setTimeout(() => {
          this.mostrar = true;
        }, 200);
      }
    },
    url: function() {
      this.mainPath = localStorage.getItem("urlApi");
      this.mainPath = this.mainPath.replace("/api", "");
      this.mainPath += this.varImg;
      this.varimgtext =
        '<div style="text-align: center;"><img  width="250" height="250" src=' +
        this.mainPath +
        ' class="img-thumbnail img-fluid rounded-circle" alt="BV"></img></div><div style="text-align: center;"><h1>' +
        this.varMensaje +
        "</h1></span></div>";
    },
    reload: function() {
      clearInterval(this.reloj);
      this.reloj  = setInterval(()=>{
        this.getData();
      },3000);
    }
  }
};
</script>
<style>
#qr_entrega .qrcode-reader__camera {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/modules/restaurant/requests/list.vue